import { put } from "typed-redux-saga";
import { appActions } from "./app";
import { authActions } from "./auth";
import { bannerActions } from "./banner";
import { campaignActions } from "./campaign";
import { couponActions } from "./coupon";
import { menuActions } from "./menu";
import { orderActions } from "./order";
import { paymentActions } from "./payment";
import { storeActions } from "./store";

export function* resetToInitialState() {
  yield* put(appActions.resetToInitialState());
  yield* put(authActions.resetToInitialState());
  yield* put(bannerActions.resetToInitialState());
  yield* put(couponActions.resetToInitialState());
  yield* put(menuActions.resetToInitialState());
  yield* put(orderActions.resetToInitialState());
  yield* put(paymentActions.resetToInitialState());
  yield* put(storeActions.resetToInitialState());
  yield* put(campaignActions.resetToInitialState());
}
